import Pagination from 'react-bootstrap/Pagination'
import styles from '../../styles/Search.module.css';

const MAX_PAGE = 7;

const PagesButton = ({ totalPageNum, curPageNum, jumpPage, navigation }) => {
  if (!(totalPageNum > 0)) return <></>;

  // Compute the visible page window around current page.
  let startPage = 0;
  let endPage = totalPageNum - 1;

  if (totalPageNum > MAX_PAGE) {
    const halfWindow = Math.floor(MAX_PAGE / 2);
    if (curPageNum - halfWindow < 0) {
      startPage = 0;
      endPage = MAX_PAGE - 1;
    } else if (curPageNum + halfWindow > totalPageNum - 1) {
      startPage = totalPageNum - MAX_PAGE;
      endPage = totalPageNum - 1;
    } else {
      startPage = curPageNum - halfWindow;
      endPage = curPageNum + halfWindow;
    }
  }

  const rows = [];
  for (let p = startPage; p <= endPage; p++) {
    const displayPageNum = p + 1;
    rows.push(
      <Pagination.Item key={p} active={p === curPageNum} onClick={() => jumpPage(p)}>
        {displayPageNum}
      </Pagination.Item>
    );
  }

  return (
    <div className={styles.pageHolder}>
      <Pagination className={styles.pagination}>
        <Pagination.Prev onClick={() => { navigation('prev') }} />
        {rows}
        <Pagination.Next onClick={() => { navigation('next') }} />
      </Pagination>
    </div>
  );
};

export default PagesButton;